import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StepperProgressBarService } from '../../../../../../services/stepper-progress-bar.service';
import { MatDividerModule } from '@angular/material/divider';
import { GettingStartedSteps } from '../../../../../../enums/getting-started-steps.enum';
import { MatButtonModule } from '@angular/material/button';
import { StepperContextService } from '../../../../../../services/stepper-context.service';
import { StepperAnswersService } from '../../../../../../services/stepper-answers.service';
import { StepperTasksService } from '../../../../../../services/stepper-tasks.service';

export enum LoanPurposeOptions {
  Purchase = 'Purchase',
  Refinance = 'Refinance'
}

@Component({
  selector: 'lgv-loan-purpose',
  standalone: true,
  imports: [CommonModule, MatDividerModule, MatButtonModule],
  templateUrl: './loan-purpose.component.html',
  styleUrls: ['./loan-purpose.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoanPurposeComponent {

  LoanPurposeOptions = LoanPurposeOptions
  isDialog = this.contextService.isDialog
  optionSelected = this.answerService.getAnswer(GettingStartedSteps.LoanPurpose) ?? ''

  @Output() stepChange = new EventEmitter<any>();
  @Output() closeDialog = new EventEmitter<any>();

  private refinanceTasks: string[] = [
    'Mortgage Statement(s)',
    "Homeowner's Insurance",
    "Homeowner's Association statement"
  ];

  constructor(
    public contextService: StepperContextService,
    public answerService: StepperAnswersService,
    public taskService: StepperTasksService
  ) { }

  ngOnInit() {
    if (this.optionSelected === LoanPurposeOptions.Refinance) {
      this.refinanceTasks.forEach(task => this.taskService.addTask(task));
    }
  }
  ngAfterViewInit() {
    if (this.optionSelected && this.contextService.purposePrepopulated) {
      // Schedule it after the current change detection cycle
      setTimeout(() => this.onNext(), 0);
    }
  }

  onAnswerSelected(ans: string) {
    this.optionSelected = ans
    if (ans !== LoanPurposeOptions.Refinance) {
      this.refinanceTasks.forEach(task => this.taskService.removeTask(task));
    }
  }

  onNext() {
    this.answerService.setAnswer(GettingStartedSteps.LoanPurpose, this.optionSelected)
    if (this.optionSelected === LoanPurposeOptions.Refinance) {
      this.refinanceTasks.forEach(task => this.taskService.addTask(task));
    } else {
      this.refinanceTasks.forEach(task => this.taskService.removeTask(task));
    }
    this.answerService.getAnswer(GettingStartedSteps.LoanPurpose) === LoanPurposeOptions.Purchase ?
      this.goToStep(GettingStartedSteps.HomebuyingStatus) : this.goToStep(GettingStartedSteps.RefinanceGoals)
  }

  onClose() {
    this.answerService.clear()
    this.contextService.clear()
    this.closeDialog.emit();
  }

  goToStep(step) {
    this.stepChange.emit(step);
  }

  isBtnSelected(option: string) {
    if (option === this.optionSelected) {
      return true
    }
  }

  isNextDisabled(): boolean {
    if (this.optionSelected === '') {
      return true
    }
    return false
  }
}
